import React, { PropsWithChildren } from 'react'

import styled from 'styled-components'

import { variables } from 'src/Styled/variables'

const StyledLink = styled.a`
  color: ${({ theme }) => theme.color.brandGreen};
  font-family: 'Segoe UI';
  font-size: ${variables.fontSize14};
  font-style: normal;
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    color: ${({ theme }) => theme.color.brandGreen};

    &:active {
      color: ${({ theme }) => theme.color.mediumGrey};
    }
  }

  &:active {
    color: ${({ theme }) => theme.color.mediumGrey};
  }

  &:visited {
    color: ${({ theme }) => theme.color.brandGreen};
    text-decoration: none;
  }
`

export type TextLinkProps = PropsWithChildren &
  React.AnchorHTMLAttributes<HTMLAnchorElement>

export const TextLink: React.FC<TextLinkProps> = ({ children, ...props }) => (
  <StyledLink {...props}>{children}</StyledLink>
)
